import { render } from "./FullIScreenIcon.vue?vue&type=template&id=5c9972e1&ts=true"
import script from "./FullIScreenIcon.vue?vue&type=script&lang=ts"
export * from "./FullIScreenIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__